import { ThemeType } from "@taxbit-private/cosmic";

const getSidebarNavWidth = (theme: ThemeType) => theme.measure.s;

export default getSidebarNavWidth;
